/**
 * CSV Export Utility
 * Converts data to CSV format and triggers download
 */
export const exportToCSV = <T extends Record<string, any>>(
  data: T[],
  columns: Array<{ key: keyof T; label: string }>,
  filename: string = "export.csv"
): void => {
  if (data.length === 0) return;

  // Create header row
  const headers = columns.map((col) => `"${col.label}"`).join(",");

  // Create data rows
  const rows = data.map((row) =>
    columns
      .map((col) => {
        const value = row[col.key];
        const stringValue = value === null || value === undefined ? "" : String(value);
        // Escape quotes in data
        return `"${stringValue.replace(/"/g, '""')}"`;
      })
      .join(",")
  );

  // Combine header and rows
  const csv = [headers, ...rows].join("\n");

  // Create blob and download
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
